import React from 'react'
import Tooltip from '../../../../control/tooltip/tooltip'
import IconButton from '@material-ui/core/IconButton'
import DocIcon from '@material-ui/icons/Description'

import useTranslate from '../../../../i18n/useTranslate'
import useCheckPermission from '../../../../utilities/checkPermission'
import constUserManualLink from '../../../../constants/userManualLink'

type SopDocViewProps = SopDocProps & { onClick: () => void }
const UserManualDocView: React.FC<SopDocViewProps> = (props) => {
    const { onClick } = props

    const translate = useTranslate()
    return (
        <>
            <Tooltip title={translate.get('LABEL.SOP_DOCUMENT')}>
                <IconButton size="small" onClick={onClick}>
                    <DocIcon style={{ fontSize: '30px' }} />
                </IconButton>
            </Tooltip>
        </>
    )
}

type SopDocProps = {}
const SopDoc: React.FC<SopDocProps> = (props) => {
    const permissionHook = useCheckPermission()
    const onClick = () => {
        if (permissionHook.isUserAdmin()) {
            window.open(constUserManualLink.officer, '_blank')
        } else if (permissionHook.isUserResearcher()) {
            window.open(constUserManualLink.researcher, '_blank')
        } else if (
            permissionHook.isUserChairmanOnly() ||
            permissionHook.isUserViceChairman() ||
            permissionHook.isUserSecretary()
        ) {
            window.open(constUserManualLink.executive, '_blank')
        } else if (permissionHook.isUserCommittee()) {
            window.open(constUserManualLink.committee, '_blank')
        }
    }
    return <UserManualDocView {...props} onClick={onClick} />
}

export default SopDoc
